import React, { useEffect, useState } from "react"
import * as geolocalization from '../../../../helpers/geolocalization'
import Map from "./Map/Map"
import Api from '../../../api'
import LoadingIcon from '../../UI/LoadingIcon/LoadingIcon'
import Card from './Card/Card';
import CompanyCard from './Card/CompanyCard';
import Searchbar from "./Searchbar/Searchbar"
import './SearchMap.css';

const startQuery = location.href.split('q=')[1] || ''

export default function SearchMap() {
  // const [coordinates, setCoordinates] = useState(null) // { lat, lng }
  const [query, setQuery] = useState(startQuery);
  const [loading, setLoading] = useState(true)

  const [trails, setTrails] = useState([])
  const [companies, setCompanies] = useState([])

  useEffect(() => {
    search()
  }, [])

  const search = async () => {
    setLoading(true)
    
    const params = {
      query,
    } 
    const data = await Api.searchTrails(params);
    setTrails(data.trails)
    setCompanies(data.companies)
    setLoading(false)
  }

  // useEffect(() => {
  //   // console.log
  //   (async () => {
  //     // first user position is needed
  //     await checkUserPosition();
  //   })()
  // }, [])

  // const checkUserPosition = async () => {
  //   const permission = await geolocalization.checkPermission();
  //   // console.log(permission);

  //   if (permission && permission.state === 'granted') {
  //     const position = await geolocalization.getPosition();
  //     // const address = await geolocalization.getAddressByCoords(position.lat, position.lng);
      
  //     // const searching = {...this.props.searching};
  //     // searching.text = address;

  //     setCoordinates({
  //       lat: position.lat, 
  //       lng: position.lng,
  //     });
  //   }
  // }

  return (
    <div>
      <section className="d-table w-100" style={{ background: "url('/img/bg.jpg') center center", height: 74 }}>
        <div className="bg-overlay" style={{ height: 80 }}></div>
      </section>

      <div className='container' style={{ marginTop: 20 }}>
        <Searchbar
          onChange={value => setQuery(value)}
          onSearch={search}
          value={query}
        />
      </div>

        <div className="container" style={{ paddingTop: 20, paddingLeft: 24, minHeight: 'calc(100vh -  180px)' }}>
          <div className="align-items-end mb-2 pb-2">
              <div style={{ position: 'relative', zIndex: 2 }}>
                <LoadingIcon loading={loading}  />
              </div>

              <div className="row">
                <div className="col-12 col-md-5">
                  <div className="scrollable" style={{ maxHeight: 'calc(100vh - 220px)', position: 'relative', zIndex: 2, paddingRight: 20 }}>
                    {/* {trails.length > 0 && (
                      <div className="alert alert-light">
                        Trasy:
                      </div>
                    )} */}
                    {trails.map(trail => <Card key={trail.id} {...trail} />)}
                    
                    {companies.length > 0 && (
                      <div>
                        <div className="alert alert-light" style={{ marginTop: 30 }}>
                          Firmy:
                        </div>
                        {companies.map(company => <CompanyCard key={company.id} {...company} />)}
                      </div>
                    )}
                  </div>
                </div>
              </div>
          </div>
        </div>

      <Map trails={trails} companies={companies} />
    </div>
  )
}